import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "section content-container" }
const _hoisted_3 = { class: "container is-fluid" }
const _hoisted_4 = { class: "columns is-3 is-multiline" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "card-content" }
const _hoisted_7 = { class: "media" }
const _hoisted_8 = { class: "media-left" }
const _hoisted_9 = { class: "image is-48x48" }
const _hoisted_10 = { class: "app-icon" }
const _hoisted_11 = ["xlink:href"]
const _hoisted_12 = { class: "media-content" }
const _hoisted_13 = { class: "title is-4" }
const _hoisted_14 = {
  key: 0,
  class: "installed-icon"
}
const _hoisted_15 = { class: "subtitle is-6" }
const _hoisted_16 = { class: "content" }

import { appsApi } from '../services/apps';
import { PublishedApp } from '../models';
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import { SET_CURRENT_APP, HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import appInsights from '@/shared/services/appInsights';
import { computed, onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'Apps',
  setup(__props) {

const router = useRouter();
const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const setCurrentApp = (app: PublishedApp) => store.dispatch(SET_CURRENT_APP, app);
const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);

const apps = ref<PublishedApp[]>([]);
const isLoading = ref(true);

onBeforeMount(async () => {
  if (!currentWorkspace.value) {
    await handleSeriousError('No workspace selected');
    return;
  }

  try {
    const loadedApps = await appsApi.listPublished(currentWorkspace.value.id);
    apps.value = loadedApps.filter((a) => !isHidden(a));
  } catch (err: any) {
    await handleSeriousError(err.message);
  } finally {
    isLoading.value = false;
  }
});

function showAppDetails(app: PublishedApp) {
  setCurrentApp(app);
  appInsights.trackEvent({ name: 'App viewed' }, { appId: app.id, workspaceId: currentWorkspace.value.id });
  router.push({ name: 'app', params: { id: app.id } });
}

function isHidden(app: PublishedApp): boolean {
  return app.status === 'hidden';
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader, {
      title: "App Store",
      description: "Discover new and existing apps - get connected!"
    }),
    _createElementVNode("section", _hoisted_2, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apps.value, (app) => {
            return (_openBlock(), _createElementBlock("div", {
              key: app.id,
              class: "column is-one-quarter-fullhd is-one-third-widescreen is-one-third-desktop is-half-tablet"
            }, [
              _createElementVNode("div", {
                class: "card has-equal-height",
                onClick: ($event: any) => (showAppDetails(app))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("figure", _hoisted_9, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                          _createElementVNode("use", {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": `#${app.icon}`
                          }, null, 8, _hoisted_11)
                        ]))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, [
                        _createElementVNode("strong", null, _toDisplayString(app.name), 1),
                        (app.isInstalled)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[0] || (_cache[0] = [
                              _createElementVNode("use", {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": "#tick"
                              }, null, -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(app.category), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(app.description), 1)
                ])
              ], 8, _hoisted_5)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}
}

})